import { AlertProps } from '@mui/material/Alert';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { ValidateBatchMinifiedResponse } from '@/validation-service/services/validationApi';
import validateTokens from '@/validation-service/tokens.json';
import coreTokens from '@/core/tokens.json';

export type PostValidateBatchActionType = {
  data: ValidateBatchMinifiedResponse | undefined;
  isError: boolean;
  isSuccess: boolean;
  error: FetchBaseQueryError | SerializedError | undefined;
};
export type PostValidateBatchStateType = {
  severity: AlertProps['severity'];
  description: string;
};

function postValidateBatchReducer(
  state: PostValidateBatchStateType,
  action: PostValidateBatchActionType,
): PostValidateBatchStateType {
  const { data, isError, isSuccess, error } = action;

  if (isError) {
    return {
      severity: 'error',
      description: error as string,
    };
  }

  if (data && isSuccess) {
    const isErrors = data.errors > 0;
    const isOnlyWarnings = !isErrors && data.warnings > 0;
    const isSuccess = data.errors === 0 && data.warnings === 0;

    if (isSuccess) {
      return {
        severity: 'success',
        description: validateTokens['VALIDATE_OK'],
      };
    } else if (isErrors) {
      return {
        severity: 'error',
        description: validateTokens['VALIDATE_FAILURE'],
      };
    } else if (isOnlyWarnings) {
      return {
        severity: 'info',
        description: validateTokens['VALIDATE_ONLY_WARNINGS'],
      };
    }

    return {
      severity: 'error',
      description: coreTokens['GENERAL_ERROR'],
    };
  }

  return state;
}

export default postValidateBatchReducer;
